// IMP START - Quick Start
import { WEB3AUTH_NETWORK, getEvmChainConfig } from "@web3auth/base";
import { getDefaultExternalAdapters } from "@web3auth/default-evm-adapter";
import { EthereumPrivateKeyProvider } from "@web3auth/ethereum-provider";
import { Web3AuthOptions } from "@web3auth/modal";
// IMP END - Quick Start

// IMP START - Dashboard Registration
const clientId =
  "BIVnZ9eW2Kl-E246h9dM-BXfcUR1GHSvzQaqCgTwp7VuMxiS4xL4PwZey-cuvrZxP_UssC-vLz6X-fOlBduUWtc"; // get from https://dashboard.web3auth.io
  
// IMP END - Dashboard Registration

// IMP START - Chain Config
// const chainId = 0xaa36a7; // Sepolia testnet
const chainId = 11155111; // Sepolia testnet

// Get custom chain configs for your chain from https://web3auth.io/docs/connect-blockchain
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const chainConfig = getEvmChainConfig(chainId, clientId)!;
// IMP END - Chain Config

// IMP START - Instantiate SDK
const privateKeyProvider = new EthereumPrivateKeyProvider({
  config: {
    chainConfig,
  },
});

const web3AuthOptions: Web3AuthOptions = {
  chainConfig,
  clientId,
  // web3AuthNetwork: WEB3AUTH_NETWORK.SAPPHIRE_MAINNET,
  web3AuthNetwork: WEB3AUTH_NETWORK.SAPPHIRE_DEVNET,
  privateKeyProvider,
  enableLogging: true,
  useCoreKitKey: true,
};
// IMP END - Instantiate SDK

// IMP START - Configuring External Wallets
const adapters = getDefaultExternalAdapters({ options: web3AuthOptions });
// IMP END - Configuring External Wallets

// IMP START - Instantiate SDK
const web3AuthContextConfig = {
  web3AuthOptions,
  // IMP START - Configuring External Wallets
  adapters: [...adapters],
  // IMP END - Configuring External Wallets
};
// IMP END - Instantiate SDK

export default web3AuthContextConfig;

